import { IApiError, IRequestMethod } from './types';

export function createFetchOptions(
  method: IRequestMethod,
  body = null,
  headers = {}
) {
  const fetchOptions: any = { method };

  if (body) {
    fetchOptions.body = JSON.stringify(body);
    fetchOptions.headers = Object.assign(
      { 'Content-Type': 'application/json' },
      headers
    );
  } else {
    fetchOptions.headers = headers;
  }

  return fetchOptions;
}

export const buildErrorFromJsonApiResponse = (
  response: any,
  payload: any
): IApiError => ({
  code: payload?.errors[0]?.code,
  status: response.status,
  statusText: response.statusText,
});
